import { render, staticRenderFns } from "./GTag.vue?vue&type=template&id=c5860e2c&"
import script from "./GTag.vue?vue&type=script&lang=js&"
export * from "./GTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports